import React from 'react'
import "./KeycloakLoader.css";
import logo from "../../image/logo.svg";

const KeycloakLoader = () => {
  return (
    <div className="coffee" >    
      <img src={logo} className="LogoOnCup"/>
      
      <div><div><div></div></div></div>
      <div><div><div></div></div></div>
      <div><div><div></div></div></div>
      <div><div><div></div></div></div>
      <div><div><div></div></div></div>
      <div><div><div></div></div></div>

      </div>
      
  )
}

export default KeycloakLoader